import { Container } from '@mui/material';
import { Redirect } from 'react-router-dom';
import { createPath, PathParams, Paths } from '../../app/router/app.router';
import { internalProjectIDs } from '../../app/router/project.router';
import { useQueryWhoAmI } from '../../core/queries/directory.queries';
import { WindowTitle } from '../../core/window-title/window-title.component';

export function WelcomePage(props: { params: PathParams<Paths.project> }) {
  const { data, isLoading } = useQueryWhoAmI();
  const firstName = data?.account.firstName;
  const lastName = data?.account.lastName;

  let username = '';

  if (!isLoading) {
    username += firstName;
    if (lastName) {
      username += ` ${lastName}`;
    }
  }

  const isRoot = internalProjectIDs.includes(props.params.projectID);

  if (isRoot) {
    return (
      <Container>
        <WindowTitle detail={username || 'Loading'} pageTitle="Welcome" />
        <h1 style={{ color: 'white', marginTop: '48px' }}>Welcome {username}</h1>
        <p style={{ color: 'white' }}>Choose a project to get started.</p>
      </Container>
    );
  }

  return <Redirect to={createPath(Paths.dashboard, props.params)} />;
}
